import {useParams} from "react-router-dom";
import { useEffect, useState } from "react";
import axios from 'axios';
import './Precall.css';
import Loading from "../common/Loading";
import ErrorPage from "../common/ErrorPage";
import { useNavigate } from "react-router-dom";
import { getTimeReturnValues } from '../Room/components/RoomTimer/hooks/useCountdown';
import Header from '../common/Header'

const Precall = (props) => {
	let { link } = useParams();
	const navigate = useNavigate();

	const [name, setName] = useState('')
	const [npm, setNpm] = useState('')
	const [sessionData, setSessionData] = useState(null)
	const [role, setRole] = useState('')
	const [isLoading, setIsLoading] = useState(true)
	const [error, setError] = useState(null)
	const [errorForm, setErrorForm] = useState(null)
	const [startTime, setStartTime] = useState(null)
	const [endTime, setEndTime] = useState(null)
	const [date, setDate] = useState(null)

	const handleSubmit = async (e) => {
		e.preventDefault()
		if (name.length === 0){
			setErrorForm("Name is required")
			return
		}

		if(npm.length === 0){
			let message = role === 'STUDENT' ? "Student ID is required" : "NIDN or Student ID is required"
			setErrorForm(message)
			return
		}

		const userData = { 'nama_peserta': name, 'npm_peserta': npm, 'role_peserta': role };
		const response = await axios.post('https://backend-ta-wiyata.herokuapp.com/create-member/', userData);
		navigate("/lobby", {state:{userData:response.data.data, sesi: sessionData}});
	}

	const handleNameChange = (e) => {
		setName(e.target.value)
		setErrorForm(null)
	}

	const handleNpmChange = (e) => {
		setNpm(e.target.value)
		setErrorForm(null)
	}

	const isLate = (time) => {
		let countDownDate = new Date(time).getTime();
		let diffTime = countDownDate - new Date().getTime()
		let [days, hours, minutes, seconds] = getTimeReturnValues(diffTime);
		return days + hours + minutes + seconds <= 0
	}

	const isStarted = (time) => {
		let countDownDate = new Date(time).getTime();
		let diffTime = countDownDate - new Date().getTime()
		let [days, hours, minutes, seconds] = getTimeReturnValues(diffTime);
		return days <= 0 && hours <= 0 && minutes < 30
	}

	const dateFormat = (date) => {
		const options = { year: 'numeric', month: 'long', day: 'numeric' };
		let dateFormatted = new Date(date);
		dateFormatted = dateFormatted.toLocaleDateString('en-GB', options)
		return dateFormatted
	}

	useEffect(() => {
		axios.get(`https://backend-ta-wiyata.herokuapp.com/precall/${link}/`)
			.then(function (response) {
				setSessionData(response.data.data)
				setRole(response.data.data['role'])
				setStartTime(response.data.data['waktu_mulai'].split(" ")[1])
				setEndTime(response.data.data['waktu_akhir'].split(" ")[1])
				let date = dateFormat(response.data.data['waktu_mulai'].split(" ")[0])
				setDate(date)
				setIsLoading(false)
			})
			.catch((error) => {
				setError(error)
				setIsLoading(false)
			})

	}, [link])

	return ( 
		<div className='precall-page'>
			<Header />
			{ isLoading && <Loading /> }
			{ sessionData !== null && !isLoading && (
				<>
					<h1 className='precall-title'>{sessionData['mata_kuliah']}</h1>
					<div className='precall-card'>
						<h4 className='precall-topic'>{sessionData['topik_diskusi']}</h4>
						<p>{date}</p>
						<p>{`Start: ${startTime} - End: ${endTime}`}</p>
						{
							
							(isStarted(sessionData['waktu_mulai']) && !isLate(sessionData['waktu_akhir'])) || role === 'HOST' ? (
								<>
									{
										errorForm !== null &&
										<h3>
											{errorForm}
										</h3>
									}
									<form onSubmit={handleSubmit} className='form-user-data'>
										<p className='precall-field-name'>Name</p>
										<input 
											type="text" 
											name="name" 
											value={name}
											onChange={handleNameChange}
											className='wiyata-text-input precall-input'
											/>
											{
											role === 'STUDENT' ? 
												<p className='precall-field-name'>Student ID</p> 
											:
												<p className='precall-field-name'>NIDN or Student ID</p>
											}
											<input 
												type="number" 
												name="npm" 
												value={npm}
												onChange={handleNpmChange}
												className='wiyata-text-input precall-input'
												/>
										{
											role === 'STUDENT' ? 
											<input type="submit" value="Join" className='wiyata-btn precall-btn' />
											: 
											<input type="submit" value="Join as Host" className='wiyata-btn precall-btn' /> 
										}
										
									</form>
								</>
							) : (
								<h3>{
									!isStarted(sessionData['waktu_mulai']) ? 
										"Session has not started" :
										"Session has ended"
										}
								</h3>
							)
						}
					</div>
				</>
			)}
			{
				!isLoading && error !== null && (
					<ErrorPage error={error} />
				)
			}
		</div>
	 );
}
 
export default Precall;